import { Endereco } from '@usucampeao/interfaces';
import { ArrayNotEmpty, IsArray, IsNotEmpty, IsNumber } from 'class-validator';
import { GatewayPagamento, ProjetoCategoria, ProjetoComissaoTipo, ProjetoTipo } from '..';
import { ProjetoEndereco } from './projeto-endereco.model';
import { ProjetoModalidadeType } from './projeto-modalidade.enum';
import { ProjetoStatus } from './projeto-status.enum';
import { ProjetoVendaStatus } from './projeto-venda-status.enum';

export type ProjetoBoundaryBoxDto = {
  latMin: number;
  latMax: number;
  lngMin: number;
  lngMax: number;
}

export class ProjetoDto {
  id: string;
  nome: string;
  descricao?: string;
  modalidade?: ProjetoModalidadeType;
  averbacao?: boolean;
  imagem: string;
  localizacao: Endereco;
  tipo: ProjetoTipo;
  categoria: ProjetoCategoria;
  cadastroDataInicio: Date;
  cadastroDataFim: Date;
  preAnaliseDataInicio: Date;
  preAnaliseDataFim: Date;
  escritorioDataInicio: Date;
  escritorioDataFim: Date;
  escritorioLocal: ProjetoEndereco;
  visitaDataInicio: Date;
  visitaDataFim: Date;
  prefeituraDataInicio: Date;
  prefeituraDataFim: Date;
  cartorioDataInicio: Date;
  cartorioDataFim: Date;
  matriculaDataInicio: Date;
  matriculaDataFim: Date;
  assembleiaLocal: ProjetoEndereco;
  assembleiaData: Date;
  vendaStatus: ProjetoVendaStatus;
  loteQuantidade: number;
  quadraQuantidade: number;
  dataCriacao: Date;
  usuarioCriacaoId: string;
  dataAtualizacao: Date;
  usuarioAtualizacaoId: string;
  status: ProjetoStatus;
  semPagamento: boolean;
  reurbGratuito: boolean;
  nucleoId: number;
  omieProjetoId: number;
  comissaoTipo: ProjetoComissaoTipo;
  comissaoReurb: number;
  comissaoReurbAverbacao: number;
  comissaoAverbacao: number;
  favorito: boolean;
  gatewayPagamento: GatewayPagamento;
  publicadoDiarioOficialData?: Date;
  cartorioRegistroData?: Date;
  tituloEntregaData?: Date;
  tituloEntregaLocalizacao?: ProjetoEndereco;
  nucleo: string;
  boundaryBox?: ProjetoBoundaryBoxDto;
}

export class ProjetoQuadraEditarDto {
  @IsArray()
  @IsNumber({}, { each: true })
  quadrasIds: number[];
}

export type ProjetoValorBaseDto = ProjetoDto & {
  valorBase: number;
}


export class ProjetoAdicionarTimesDto {
  @IsArray()
  @ArrayNotEmpty()
  @IsNumber({}, { each: true })
  @IsNotEmpty()
  timeIds: number[];
}

export const PROJETOS_HABILITADOS_ASSINATURA_CONTRATO_FISICO = [
  '9E0cpVBswS3PhZfRriOc',
  'uNsn9losNCYlTsSNhndE'
];